import React from 'react';
import {Trans} from 'gatsby-plugin-react-i18next';
import {links} from 'global.config';
import {MenuLink} from '../utils/types';

export const resources: MenuLink[] = [
  {icon: 'blog', to: 'blog', title: <Trans>Blog</Trans>},
  {icon: 'support', to: 'support', title: <Trans>Support</Trans>},
  {icon: 'globe', to: links.docs, title: <Trans>Docs</Trans>},
  {icon: 'recurring', slug: 'affiliate-program', title: <Trans>Become a MONEI Affiliate</Trans>},
  {icon: 'legal', slug: 'payments-glossary', title: <Trans>Payments Glossary</Trans>},
  {
    icon: 'calculator',
    slug: 'interchange-fee-calculator',
    title: <Trans>Interchange Fee Calculator</Trans>
  },
  {icon: 'globe', to: 'https://monei.com/about-us/', title: <Trans>About Us</Trans>},
  {icon: 'partner_integration', to: 'https://monei.com/partners/', title: <Trans>Partners</Trans>}
];
